export default {
  title: {
    id: 'product_instructions_modal_title',
    defaultMessage: 'Instructions and documents',
  },
  productTitle: {
    id: 'product_instructions_modal_product_title',
    defaultMessage: 'Get to know your {title}:',
  },
  close: {
    id: 'product_instructions_modal_close',
    defaultMessage: 'Close',
  },
}
